import localeNl from '@angular/common/locales/nl';
import { EnvironmentInterface } from '@sk/sk-interfaces';

export const environment : EnvironmentInterface = {
  production: true,
  language: 'nl-NL',
  scheduleCheck: true,
  region: 'nl',
  locale : localeNl,
  firebase: {
    apiKey: "AIzaSyBWXQXiCmM-E8hJZ-6PjCmGlvsKSMPyhWg",
    authDomain: "joblog-nederland.firebaseapp.com",
    databaseURL: "https://joblog-nederland.firebaseio.com",
    projectId: "joblog-nederland",
    storageBucket: "joblog-nederland.appspot.com",
    messagingSenderId: "373809780594",
    appId: "1:373809780594:web:5dffe59a4cf3c8007aafeb",
    measurementId: "G-60ZNVCX84P"
  },
  api_url: 'https://europe-west1-joblog-nederland.cloudfunctions.net',
  release: 'p.nl_nl 0.1.00',
  base_url:  'https://app.joblog24.nl',
  releaseCompany: 'JobLog Nederland B.V.',
};
